import React, { useContext, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  useTheme,
} from "@mui/material";
import { useMutation } from "@apollo/client";
import { ADD_POLE_TO_SET } from "../graphql/gqlPoleset";
import { SnackbarContext } from "../contexts/snackbarContext";
import { T } from "../components/T";

const AddPoleToSetModal = ({
  isOpen,
  close,
  setId,
}: {
  isOpen: boolean;
  close: () => void;
  setId: string;
}) => {
  const theme = useTheme();

  const [length, setLength] = useState("");
  const [color, setColor] = useState("#ff0000");
  const { openSuccessSnackbar, openErrorSnackbar } =
    useContext(SnackbarContext);

  const [addPoleToSet] = useMutation(ADD_POLE_TO_SET, {
    onCompleted: () => {
      close();
      setLength("");
      openSuccessSnackbar(<T str="Pole added" />);
    },
    onError: (error) => {
      openErrorSnackbar(error.message || <T str="Something went wrong" />);
    },
  });

  const handleAddPoleToSet = () => {
    addPoleToSet({
      variables: {
        polesetId: setId,
        poleType: {
          length: Math.round(Number(length) * 100) / 100,
          color,
          radius: 0.06,
        },
      },
    });
  };

  return (
    <Dialog
      open={isOpen}
      onClose={close}
      PaperProps={{
        sx: {
          bgcolor: theme.palette.background.paper,
          color: theme.palette.text.primary,
        },
      }}
    >
      <DialogTitle>
        <T str="Add pole" />
      </DialogTitle>
      <DialogContent>
        <TextField
          label={<T str="Length (m)" />}
          value={length}
          onChange={(e) => {
            if (e.target.value === "") setLength("");
            else if (Number(e.target.value)) setLength(e.target.value);
            else if (Number(e.target.value) === 0) setLength(e.target.value);
          }}
          fullWidth
          color="secondary"
          required
          type="text"
          sx={{
            mb: 2,
            mt: 2,
          }}
        />
        <TextField
          label={<T str="Color" />}
          value={color}
          onChange={(e) => {
            setColor(e.target.value);
          }}
          fullWidth
          color="secondary"
          required
          type="color"
          sx={{
            mb: 2,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={close}>
          <T str="Cancel" />
        </Button>
        <Button
          onClick={handleAddPoleToSet}
          variant="contained"
          color="secondary"
          disabled={!length}
        >
          <T str="Add" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddPoleToSetModal;
